import { Loader } from '@s4l/ds'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import React, { useRef } from 'react'
import { useIntersection } from 'react-use'
import styles from './styles.module.css'
import TrustPilotWidgetContent from './TrustPilotWidgetContent'

interface TrustPilotWidgetProps {
  lazyLoad?: boolean
  theme?: 'dark' | 'light'
}

const TrustPilotWidget = ({ lazyLoad = true, theme = 'light' }: TrustPilotWidgetProps) => {
  const layoutRef = useRef<HTMLDivElement>(null)

  const intersection = useIntersection(layoutRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  })

  return (
    <div className={styles.layout} ref={layoutRef}>
      {!lazyLoad || intersection?.intersectionRatio ? (
        <TrustPilotWidgetContent theme={theme} />
      ) : (
        <Loader.Dots />
      )}
    </div>
  )
}

TrustPilotWidget.displayName = 'TrustPilotWidget'
export default withErrorBoundary(TrustPilotWidget)
